import PropTypes from 'prop-types';

/**
 * @typedef {Object} SearchQuery
 * @property {string} [originCode]
 * @property {string} [departureDate]
 * @property {string} [returnDate]
 * @property {string|number} [adults]
 * @property {string|number} [children]
 * @property {string|number} [infants]
 */
const SearchQuery = {
  originCode: PropTypes.string,
  departureDate: PropTypes.string,
  returnDate: PropTypes.string,
  adults: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  infants: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default SearchQuery;
